var GenericView = require('views/generic.view.ts');
var Handlebars = require('handlebars');
var Template = require('text-loader!../templates/flexibility_table.template.html');
require('../../libs/handlebars/handlebars-helpers.ts');

var TheView = GenericView.extend({
    el: '.flexibility .table-container',
    tagName: '',
	template: Handlebars.compile(Template),
	initialize: function (options) {
        this.render();
    },
    superRender: GenericView.prototype.render,
    render: function () {
        this.superRender();
        var params = {
            zones: [
                {"title": "Winter", "zoneType": "Winter"},
                {"title": "Spring", "zoneType": "Spring"},
                {"title": "Summer", "zoneType": "Summer"},
                {"title": "Autumn", "zoneType": "Autumn"},
            ]
        };

        this.$el.html(this.template(params));
    }
});

module.exports= TheView;